<template lang="html">
 	<div class="downloadList-container">
        <div class="breadCrumb-container">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item>{{$t('message.changePassword')}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

        <div class="body-container">
            <div class="table-container password-container verifone-panel">
                <div class="password-item">
                    <div class="item-left">
                        <span>{{$t('message.usernameChange')}}</span>
                    </div>
                    <div class="item-right">
                        <span>{{userName}}</span>
                    </div>
                </div>

                <div class="password-item">
                    <div class="item-left">
                        <span class="required-icon">*</span><span>{{$t('message.currentPassword')}}</span>
                    </div>
                    <div class="item-right">
                        <el-input v-model="originalPassword" type="password"></el-input>
                    </div>
                </div>

                <div class="password-item">
                    <div class="item-left">
                        <span class="required-icon">*</span><span>{{$t('message.newPassword')}}</span>
                    </div>
                    <div class="item-right">
                        <el-input v-model="newPassword" maxlength="16" type="password" :placeholder="$t('message.content')"></el-input>
                    </div>
                </div>

                <div class="password-item">
                    <div class="item-left">
                        <span class="required-icon">*</span><span>{{$t('message.confirmPassword')}}</span>
                    </div>
                    <div class="item-right">
                        <el-input v-model="newAgain" maxlength="16" type="password" :placeholder="$t('message.content')"></el-input>
                    </div>
                </div>

                <div class="submit-container">
                    <el-button class="verifone-btn" type="primary" plain icon="el-icon-back" @click="callBack">{{$t('message.back')}}</el-button>
                    <el-button class="verifone-btn" type="primary" icon="el-icon-document" @click="submitModify">{{$t('message.submit')}}</el-button>
                </div>
        	</div>
        </div>

 	</div>
</template>

<script>
export default {
	data() {
		return {
            userName: sessionStorage.getItem('verifoneUsername'),
            originalPassword: '',
            newPassword: '',
            newAgain: '',
            passwordCheck: this.$t('message.passwordCheck'),
            inputCheck: this.$t('message.inputCheck'),
            sameCheck:this.$t('message.sameCheck'),
            /*validCheck:this.$t('message.validCheck'),*/ /* 密码验证*/
            modifySuccess: this.$t('message.modifySuccess'),
            logout: this.$t('message.logout'),
            passWordLength:this.$t('message.passWordLength'),
		}
	},
  /**
   * 监听密码的长度
   */
  watch:{
    newAgain:function (val) {
      if(val.length>15){
        this.$message({
          type: "error",
          message: this.$i18n.t('message.passWordLength'),
          duration: '3000',
        });
        return;
      }
    },
    newPassword:function (val) {
      if(val.length>15){
        this.$message({
          type: "error",
          message: this.$i18n.t('message.passWordLength'),
          duration: '3000',
        });
        return;
      }
    }
  },
	methods: {
		handleClick(row) {
            console.log(row);
        },
        handleDetail(row) {
            let id = row.taskId;

            if(row.taskType == 0) {
                this.queryTaskDetail(0, id);
            }else if(row.taskType == 1) {
                this.queryTaskDetail(1, id);
            }else if(row.taskType == 2) {
                this.queryTaskDetail(2, id);
            }
        },
        handleStopTask(row) {
            this.cancelId = row.taskId;
            this.cancelDialogVisible = true;
        },
        callBack() {
            // this.$router.go(-1);
            this.$router.replace('/dashboard');
        },
   /*密码验证*/
   /* checkPassword(){
		  const reg=/[a-z]/.test(this.newPassword);
      const regg=/[A-Z]/.test(this.newPassword);
      const regs=/[0-9]/.test(this.newPassword);
      const leg=/[a-z]/.test(this.newAgain);
      const legg=/[A-Z]/.test(this.newAgain);
      const legs=/[0-9]/.test(this.newAgain);
      if(reg&&regg&&regs||leg&&legg&&legs){
        return true;
      }else{
        this.$message({
          type: "error",
          message: this.validCheck,
          duration:'3000',
        });
        return;
      }
     },*/

        submitModify() {
            let that = this,
                obj = {
                    current: this.originalPassword,
                    newPwd: this.newPassword
                };
          /*密码验证*/
         /* if(!this.checkPassword()){
            return;
          }*/
            if(!this.originalPassword || this.originalPassword == '' || !this.newPassword || this.newPassword == '' || !this.newAgain || this.newAgain == '') {
                this.$message({
                    type: "error",
                    message: this.inputCheck,
                    duration:'3000',
                });
                return;
            }
            if(this.newPassword != this.newAgain) {
                this.$message({
                    showClose: true,
                    message: this.passwordCheck,
                    duration:'3000',
                    type: 'error'
                });
                return;
            }
          if(this.originalPassword == this.newAgain&& this.originalPassword==this.newPassword) {
            this.$message({
              showClose: true,
              message: this.$i18n.t('message.sameCheck'),
              duration:'3000',
              type: 'error'
            });
            return;
          }

            this.$axios({
                method: 'post',
                url: '/marketplace/user/password',
                headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
                data: obj
            }).then(response => {
                if (response.data.resultCode != 0) {
                    this.$message({
                        type: "error",
                        message: response.data.desc,
                        duration:'3000',
                    });
                    console.log(response.data.desc);
                    return;
                }else {
                    this.$message({
                        type: "success",
                        message: this.modifySuccess,
                        duration:'3000',
                    });

                    setTimeout(function() {
                        that.submitQuit();
                    }, 2000);

                }
            }).catch((err) => {
                console.log(err);
            });
        },
        submitQuit() {
            let that = this;

            this.$axios({
                method: 'post',
                url: '/marketplace/logout',
                headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')}
            }).then(response => {
                if (response.data.resultCode != 0) {
                    that.$message({
                        type: "error",
                        message: response.data.desc,
                        duration:'3000',
                    });
                    console.log(message);
                    return;
                }else {
                    this.$message({
                        type: "success",
                        message: this.logout,
                        duration:'3000',
                    });

                    sessionStorage.setItem('verifoneLoginFlag', false);

                    setTimeout(function() {
                        that.$router.replace('/login');
                    }, 1000);
                }
            }).catch((err) => {
                console.log(err);
            });
        }
	}

}
</script>

<style lang="css" scoped="scoped">
.table-container {
	margin-top: 60px;
    padding: 12vh 10vw;
}
.password-container {
    height: 70vh;
}
.password-item {
    display: flex;
    display: -webkit-display;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 20px;
    color: #666;
}
.item-left {
    width: 18vw;
    text-align: right;
}
.item-right {
    padding-left: 15px;
    width: 28vw;
}
.required-icon {
    color: red;
    font-size: 20px;
}
.submit-container {
    margin-top: 20vh;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/page/ModifyPassword.vue